import { useContext } from "react";
import { WebsocketContext } from "../modules/WebSocket/WebSocketProvider";

export const useWebsocket = () => useContext(WebsocketContext);
